const isMobile = (): boolean => document.documentElement.clientWidth < 900

const getElementByIdForDevice = (selector: string): HTMLElement | null => {
  return document.querySelector(`${isMobile() ? '.mobile' : '.desktop'} ${selector}`)
}

export const initContentTabs = (): void => {
  const contentTabs = getElementByIdForDevice('#toc')
  const contentTabsSpacer = document.getElementById('content-tabs-spacer')

  if (!contentTabs || !contentTabsSpacer) return

  const tabsOffset = contentTabs.offsetTop

  const handleScroll = (): void => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (currentScrollTop >= tabsOffset) {
      contentTabs.classList.add('sticky')
      contentTabsSpacer.classList.add('active')
      contentTabs.classList.remove('hidden')
    } else {
      contentTabs.classList.remove('sticky', 'hidden')
      contentTabsSpacer.classList.remove('active')
    }
  }

  window.addEventListener('scroll', handleScroll)
  handleScroll()
}

export const initTabLinks = async (): Promise<void> => {
  const tabPractice = getElementByIdForDevice('#tab-practice')
  const tabWorksheets = getElementByIdForDevice('#tab-worksheets')

  const [practicePart, worksheetsPart] = await Promise.all([
    findElementByWord('practice'),
    findElementByWord('worksheets')
  ])

  if (practicePart && tabPractice) {
    tabPractice.setAttribute('href', `#${practicePart.id}`)
  }

  if (worksheetsPart && tabWorksheets) {
    tabWorksheets.setAttribute('href', `#${worksheetsPart.id}`)
  }
}

const findElementByWord = (word: string): Promise<HTMLElement | null> => {
  return new Promise((resolve) => {
    const search = (): HTMLElement | null =>
      Array.from(document.querySelectorAll('h2')).find(h2 => h2.id.includes(word)) || null

    const found = search()
    if (found) return resolve(found)

    const observer = new MutationObserver(() => {
      const el = search()
      if (el) {
        observer.disconnect()
        resolve(el)
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })

    setTimeout(() => {
      observer.disconnect()
      resolve(null)
    }, 5000)
  })
}
